//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";

export default {
    name: "AppendVariable",
    components: { AQDropdown },
    props: {
        label: String,
        filters: Object,
        withResetAfterSelect: { type: Boolean, default: true },
        initialValue: String,
        additionalDDLVariables: Array,
        readonly: Boolean
    },
    data() {
        return {
            selectedValue: null,
            options: [],
            resetValue: false,
            defaultValue: ""
        };
    },
    computed: {
        ...mapGetters("smartContractDesigner", ["selectedFunctionVariables"]),
        getSelectedFunctionVariables() {
            return [
                ...this.selectedFunctionVariables,
                ...(this.additionalDDLVariables || []) // also add additional prop recieved ddl variables
            ];
        }
    },
    created() {
        if (this.initialValue) {
            this.defaultValue = this.initialValue;
        }
    },
    mounted() {
        if (this.initialValue) {
            this.defaultValue = this.initialValue;
        }

        if (!this.filters || (this.filters && this.filters.length === 0)) {
            this.options = this.selectedFunctionVariables;
        } else {
            //   this.options = this.selectedFunctionVariables();
        }
    },
    methods: {
        valueChanged(val) {
            if (val.length) {
                this.$emit(
                    "selectedVariable",
                    this.getSelectedFunctionVariables.find(elem => elem.value === val[0].value)
                );
                this.selectedValue = val[0].value;
                if (this.withResetAfterSelect) {
                    setTimeout(() => {
                        this.resetValue = true;
                    }, 0);
                    this.resetValue = false;
                }
            }
        }
    }
};
